module.exports = __webpack_public_path__ + "static/media/testimonal02.069b66f2.webp";